//117
import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import { CushionMaterial, PaintColorMaterial } from '../../utils/materials';

export function Cokie_counter_stool_painted(props) {
  const { nodes, materials, scene } = useGLTF(
    'models/Cokie Counter Stool - Painted.glb',
  );

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-cokie_counter_stool_painted-chair_frame',
    aoIntensity,
  );
  useSetMaterialFinish(
    CushionMaterial,
    currentMaterialFinish.cushionFinish,
    defaultFinish.cushionFinish,
    'ao-cokie_counter_stool_painted-cushion',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      {currentFinishes.cushionFinish !== 'No Cushion' ? (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Stiches.geometry}
            material={materials.Stiches}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cushion.geometry}
            material={CushionMaterial}
          />
        </>
      ) : null}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Chair_Frame.geometry}
        material={PaintColorMaterial}
      />
      <Shadow model={'Cokie Counter Stool - Painted'} />
    </group>
  );
}
